import { connect } from 'react-redux';
import ReportHealthInsuranceBonusTable from '../components/ReportHealthInsuranceBonusTable';

export default connect()(ReportHealthInsuranceBonusTable);
